var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11763 3.82359H2.41176C2.03733 3.82359 1.67825 3.97233 1.41349 4.23708C1.14874 4.50184 1 4.86092 1 5.23534V11.5882C1 11.9627 1.14874 12.3218 1.41349 12.5865C1.67825 12.8513 2.03733 13 2.41176 13H8.76466C9.13908 13 9.49816 12.8513 9.76292 12.5865C10.0277 12.3218 10.1764 11.9627 10.1764 11.5882V10.8824M9.47053 2.41183L11.5882 4.52946M12.5658 3.53065C12.8438 3.25264 13 2.87558 13 2.48242C13 2.08926 12.8438 1.7122 12.5658 1.43419C12.2878 1.15618 11.9107 1 11.5176 1C11.1244 1 10.7474 1.15618 10.4694 1.43419L4.52939 7.35298V9.47061H6.64702L12.5658 3.53065Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyNow);
export default __webpack_public_path__ + "static/media/apply-now.23a9468cc306be2781090b3074973c98.svg";
export { ForwardRef as ReactComponent };